import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CraRoutingModule } from './cra-routing.module';
import { ListCraComponent } from './components/list-cra/list-cra.component';
import { WorkflowCraComponent } from './components/workflow-cra/workflow-cra.component';
import { ValidCraComponent } from './components/valid-cra/valid-cra.component';
import { DetailsCraComponent } from './components/details-cra/details-cra.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ListWorkflowComponent } from './components/list-workflow/list-workflow.component';
import { PaginationModule } from './../../shared/components/pagination/pagination.module';
import { WorkflowClientconsultantComponent } from './components/workflow-clientconsultant/workflow-clientconsultant/workflow-clientconsultant.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { WorkflowConsultantComponent } from './components/workflow-consultant/workflow-consultant/workflow-consultant.component';
import { UpdateWorkflowComponent } from './components/update-workflow/update-workflow/update-workflow.component';
import { DetailWorkflowgenComponent } from './components/detail-workflowgen/detail-workflowgen/detail-workflowgen.component';
import { DetailCraComponent } from './components/detail-cra/detail-cra/detail-cra.component';
import { CalendarModule } from 'primeng/calendar';
import { QuillModule } from 'ngx-quill';
import { SharedModule } from '@shared/shared.module';
import { MatMenuModule } from '@angular/material/menu';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
@NgModule({
  declarations: [
    ListCraComponent,
    WorkflowCraComponent,
    ValidCraComponent,
    DetailsCraComponent,
    ListWorkflowComponent,
    WorkflowClientconsultantComponent,
    WorkflowConsultantComponent,
    UpdateWorkflowComponent,
    DetailWorkflowgenComponent,
    DetailCraComponent,
  ],
  imports: [
    CommonModule,
    CraRoutingModule,
    NgSelectModule,
    PaginationModule,
    NgxSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    CalendarModule,
    SharedModule,
    MatMenuModule,
    MatFormFieldModule,
    MatSelectModule,
    QuillModule.forRoot({
          modules: {
            syntax: true,
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'], // toggled buttons
              ['blockquote', 'code-block'],
    
              [{ header: 1 }, { header: 2 }], // custom button values
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
              [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
              [{ direction: 'rtl' }], // text direction
    
              [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
    
              [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              [{ font: [] }],
              [{ align: [] }],
    
              ['clean'], // remove formatting button
            ],
          },
        }),
  ],
})
export class CraModule {}
